import { FieldOptions, EasyCardField, EasyTabField, EasyExpansionPanelField } from '../index';
import { EasyField } from '../baseClasses/easyField';
import { EasyContainer } from '../baseClasses/easyContainer';
import { EasyForm } from '../baseClasses/easyForm'

export class EasyAccordionField extends EasyContainer {
    controlType = 'accordion';
    form: EasyForm

    constructor(form: EasyForm, options: FieldOptions<any> = {}) {
        super("", options, form, 'accordion');
        this.form = form;
    }

    addExpansionPanel(header: string, options: FieldOptions<any> = {}): EasyExpansionPanelField {
        let container = new EasyExpansionPanelField(header, options, this.form)
        this.containers.add(container);
        return container;
    }
}